import React from "react";
import { Grid } from "@mui/material";
import classes from "./account-management.module.css";
import Login from "./login/login";
import LandingBg from "../../components/landing-bg/landingBg";
import { Route, Routes, Navigate } from "react-router";
import ResetPassword from "./reset-password/reset-password";
import ForgotPassword from "./forgot-password/forgot-password";

const AccountManagement = () => {
   return (
      <div className={classes.container}>
         <Grid container>
            <Grid item lg={8} xs={12} className={classes.imageGriid}>
               <LandingBg />
            </Grid>

            <Grid item lg={4} xs={12}>
               <Routes>
                  <Route
                     path="/login"
                     index
                     element={<Login />}
                     caseSensitive
                  />
                  <Route
                     path="/forgot-password"
                     element={<ForgotPassword />}
                     caseSensitive
                  />
                  <Route
                     path="/reset-password"
                     element={<ResetPassword />}
                     caseSensitive
                  />
                  <Route
                     path="/*"
                     element={<Navigate to="/login" />}
                     caseSensitive
                  />
               </Routes>
            </Grid>
         </Grid>
      </div>
   );
};

export default AccountManagement;
